// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"popupModal-m__modal-wrapper__W5FDc","modal":"popupModal-m__modal__Ia5a0"};